import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OnboardingRunPage } from "@/features/onboarding/OnboardingRunPage";

const search = z.object({
  tab: z.enum(["steps", "items"]).optional(),
});

export const Route = createFileRoute("/_app/onboarding/$run")({
  validateSearch: search,
  component: () => {
    const { run } = Route.useParams();
    return <OnboardingRunPage runId={run} search={Route.useSearch()} />;
  },
});
